import { CSSProperties } from 'react';
import { borderRadius } from '../../theme/borderRadius';
import { colors, hexToRgbA } from '../../theme/colors';
import spacing, { spacingInUnits } from '../../theme/spacing';

export const formikTopLabelAbsoluteStyles = {
  position: 'absolute',
  left: spacingInUnits.xxs,
  top: -spacingInUnits.medium - 2,
  width: '100%',
};

export const formikTopLabelStyles = {
  marginBottom: spacing.xs,
};

export const formikFieldBorderColor = hexToRgbA(colors.backgroundLight, 1);
export const formikFieldBaseStyles: CSSProperties = {
  backgroundColor: 'transparent',
  borderRadius: borderRadius.large,
  border: `solid 1px ${formikFieldBorderColor}`,
};
